if (!window.__tabsContentInit) {
  window.__tabsContentInit = true;

  function pauseMedia(container) {
    container.querySelectorAll('iframe').forEach(function (iframe) {
      try {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
          '*'
        );
        iframe.contentWindow.postMessage(
          JSON.stringify({ method: 'pause' }),
          'https://player.vimeo.com'
        );
      } catch (e) {}
    });

    container.querySelectorAll('audio').forEach(function (audio) {
      audio.pause();
    });
  }

  var tabObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'hidden' && mutation.target.hidden) {
        pauseMedia(mutation.target);
      }
    });
  });

  // Un seul audio à la fois — capture phase car 'play' ne bubble pas
  document.addEventListener('play', function (e) {
    if (e.target.tagName === 'AUDIO') {
      document.querySelectorAll('audio').forEach(function (audio) {
        if (audio !== e.target && !audio.paused) {
          audio.pause();
        }
      });
    }
  }, true);

  function init() {
    document.querySelectorAll('.tabs__content').forEach(function (panel) {
      tabObserver.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
